import { isEqual } from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

/**
 * Provides a selector creator that will compare arrays using shallow equality.
 * All other types will follow standard equality.
 * This is particularly useful if the underlying array data is stable but the arrays themselves are often recreated.
 */
export const createArrayShallowEqualSelector = createSelectorCreator(defaultMemoize, (a, b) => {
  if (a === b) return true;
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((val, i) => val === b[i]);
  }
  return false;
});
